export const environment = {
  production: true,
  recaptchaKey: '6LfeIfMZAAAAAGk3qNo5RxZWnYJaq821DTWLqS7c',
};
